import React from 'react';
import { Variable } from 'src/api/types';
import { isWorkspaceOrGlobalVariable } from '../shared/formula';
import {
  IconVariableWorkspace,
  IconVariableAssessment,
  IconVariableWorkspaceCustom,
  IconVariableAssessmentCustom,
} from 'src/assets/dynamicSvg';

// Shared icon selection logic for chips and dropdown rows (ported from the draft-js
// DecoratorComponent / SuggestionEntryComponent).
export const getVariableIcon = (variable: Variable, workspaceVariableNames?: Set<string>): React.ReactNode => {
  const isWorkspaceVar = isWorkspaceOrGlobalVariable(variable);
  const isAssessmentVar = !isWorkspaceVar;
  const isOverride = isAssessmentVar && workspaceVariableNames?.has(variable.name);

  if (isOverride) return <IconVariableAssessmentCustom />;
  if (variable.isGlobal) return <IconVariableWorkspace />;
  if (isWorkspaceVar) return <IconVariableWorkspaceCustom />;
  return <IconVariableAssessment />;
};
